'use client'
import React from "react";
import squareLoader from "../public/assets/loaders/square.json";
import { cn } from "@/lib/utils/global-utils";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });
const LewkLoader = ({ className }: { className?: string }) => {
  return (
   
    <Lottie
      className={cn(" aspect-square size-20", className)}
      animationData={squareLoader}
    />
  );
};

export default LewkLoader;
